<template>
  <div class="online-letter">
    <template v-if="!letter.gfLetterStatus">
      <el-descriptions :column="3" size="medium">
        <el-descriptions-item label="保函状态">
          <div class="flex col-top">
            <status-tag type="danger" label="未开立" size="small">-</status-tag>
            <a-button
              style="padding: 0 24px"
              type="link"
              @click="applyOnlineLetter"
            >
              在线保函申请
            </a-button>
          </div>
        </el-descriptions-item>
      </el-descriptions>

      <el-divider />
      <ol class="tip">
        <li>
          {{
            guaranteePayMethodDict.ONLINE_LETTER.label
          }}由江咨金发线上服务平台提供；
        </li>
        <!--<li>-->
        <!--  线下保函上传支持pdf/png/jpg/zip/rar格式，单个文件最大50MB，最多上传1个。-->
        <!--</li>-->
      </ol>
    </template>

    <template v-else>
      <el-descriptions :column="3" size="medium">
        <el-descriptions-item label="保函状态">
          <div class="flex-col">
            <div class="flex col-top flex-wrap">
              <status-tag
                :label="letterStatusEntry.label"
                :type="letterStatusEntry.type"
                size="small"
                class="m-r-24"
              />
              <!-- 审核中的按钮操作 -->
              <a-button
                v-if="showProgressButton"
                type="link"
                style="padding: 0"
                class="m-r-8"
                @click="toThirdPlatform"
              >
                查看进度
              </a-button>
              <a-button
                v-if="showWithdraw"
                style="padding: 0"
                type="link"
                class="m-r-8"
                @click="handleRefund"
              >
                申请撤回
              </a-button>
              <!-- 开立成功下的按钮操作 -->
              <a-button
                v-if="showRefundButton"
                type="link"
                style="padding: 0"
                class="m-r-8"
                @click="handleRefund"
              >
                申请退款
              </a-button>
              <!-- 开立失败下的按钮操作 -->
              <a-button
                v-if="showReApply"
                type="link"
                style="padding: 0"
                class="m-r-8"
                @click="applyOnlineLetter"
              >
                重新在线保函申请
              </a-button>
              <!-- 退款失败，查看申请原因的按钮 -->
              <a-button
                v-if="showRefundFailButton"
                type="link"
                style="padding: 0"
                class="m-r-8"
                @click="toThirdPlatform"
              >
                查看退款失败原因
              </a-button>
            </div>
            <!-- 退款中状态提示 -->
            <div
              v-if="
                letter.gfLetterStatus ===
                  guaranteeLetterOnlineRefundStatusDict.REFUNDING.value
              "
              class="tip m-t-4"
            >
              具体到账情况，请前往江咨金发金融服务平台查询
            </div>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间">
          <span>{{ letter.gfLetterApplyTime || '-' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="支付金额">
          <span class="m-r-8">{{ letter.gfLetterFee | moneyFilter }}元</span>
          <money-in-cn :money="letter.gfLetterFee || '0'" />
        </el-descriptions-item>
        <template
          v-if="
            letter.gfLetterStatus ===
              guaranteeLetterOnlineStatusDict.OPENED.value
          "
        >
          <el-descriptions-item label="开立时间">
            <span>{{ letter.gfLetterStartTime || '-' }}</span>
          </el-descriptions-item>
        </template>
      </el-descriptions>

      <!-- 开立失败原因 -->
      <div v-if="letter.gfLetterRemark" class="opinion">
        不通过原因：{{ letter.gfLetterRemark || '-' }}
      </div>

      <el-divider />
      <div class="tip">
        <span>{{
          guaranteePayMethodDict.ONLINE_LETTER.label
        }}申请由江咨金发线上服务平台提供</span>
        <a-button
          type="link"
          class="m-l-8"
          style="font-size: 12px; padding: 0"
          @click="toThirdPlatform"
        >
          立即前往
        </a-button>
      </div>
    </template>
  </div>
</template>

<script>
// 组件
import MoneyInCn from '@/components/common/MoneyInCn'
import StatusTag from '@/components/common/StatusTag'
// 工具
import { strToThousands } from '@/utils/utils'
import {
  guaranteeLetterOnlineClaimStatusDict,
  guaranteeLetterOnlineRefundReasonDict,
  guaranteeLetterOnlineRefundStatusDict,
  guaranteeLetterOnlineStatusDict,
  guaranteeLetterTypeDict,
  guaranteePayMethodDict
} from '@/dictionary/project/common'
import {
  applyRefundLetterApi,
  getGuaranteeLetterDetailApi,
  getOnlineLetterUrlApi,
  setGuaranteePayMethodApi
} from '@/api/supplier/bid'
import { differenceInHours } from 'date-fns'
import { bidInviteBidStatusDict } from '@/dictionary/project/bid'
import { mapState } from 'vuex'

/**
 * @description 线上保函组件
 */
export default {
  name: 'OnlineLetter',

  components: { MoneyInCn, StatusTag },

  filters: {
    moneyFilter(val) {
      return strToThousands(val) || '0'
    }
  },

  props: {
    orderId: {
      type: [String, Number],
      required: true
    },

    tradeId: {
      type: [String, Number],
      required: true
    },

    // 变更公告id
    changeNoticeId: {
      type: [String, Number],
      default: ''
    },

    // 流标公告id
    closeNoticeId: {
      type: [String, Number],
      default: ''
    },

    // 允许申请撤回的时间节点
    canWithdrawTimeNode: {
      type: String,
      default: ''
    },

    // 项目状态
    orderStatus: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      guaranteePayMethodDict,
      guaranteeLetterOnlineStatusDict,
      guaranteeLetterOnlineRefundStatusDict,
      guaranteeLetterOnlineClaimStatusDict,
      guaranteeLetterOnlineRefundReasonDict,

      letter: {
        // 保函申请类型
        applyType: guaranteeLetterTypeDict.ONLINE.value,
        // 保函文件id
        gfLetterFileIds: '',
        // 保函状态
        gfLetterStatus: '',
        // 申请时间
        gfLetterApplyTime: '',
        // 支付金额（保函金额、保费）
        gfLetterFee: '',
        // 退款状态
        refundStatus: '',
        // 理赔状态
        compensateStatus: '',
        // 保函生效开始时间
        gfLetterStartTime: '',
        // 保函详情地址
        applyUrl: '',
        // 保函有效期
        gfLetterDays: '',
        // 保函申请失败原因
        gfLetterRemark: ''
      }
    }
  },

  computed: {
    ...mapState('systemTime', ['systemMillisecond']),

    letterStatusEntry() {
      /**
       * 如果refundStatus有值，则进入退款流程；
       * 如果compensateStatus有值，则进入理赔流程；
       * 优先展示退款或理赔状态，这两个状态值不会同时有值
       * 注：供应商端不显示理赔流程，当保函进入理赔流程时，不允许供应商申请退款
       */
      if (this.letter.refundStatus) {
        return (
          guaranteeLetterOnlineRefundStatusDict.translate(
            this.letter.refundStatus
          ) || {}
        )
      }
      return (
        guaranteeLetterOnlineStatusDict.translate(this.letter.gfLetterStatus) ||
        {}
      )
    },

    // 显示查看进度按钮
    showProgressButton() {
      // 保函申请状态为审核中，或退款状态为退款中时显示
      const { APPLYING, AUDITING } = guaranteeLetterOnlineStatusDict
      const LETTER_STATUS_TRUTH = [APPLYING, AUDITING]
        .map(item => item.value)
        .includes(this.letter.gfLetterStatus)
      const REFUND_TRUTH =
        this.letter.refundStatus ===
        guaranteeLetterOnlineRefundStatusDict.REFUNDING.value
      return LETTER_STATUS_TRUTH || REFUND_TRUTH
    },

    // 显示申请撤回按钮
    showWithdraw() {
      // 当前时间距离开标时间在24小时以内且保函状态为审核中
      const differenceHours = differenceInHours(
        new Date(this.canWithdrawTimeNode),
        new Date(this.systemMillisecond)
      )
      const in24Hours = differenceHours > 0 && differenceHours <= 24
      return (
        this.letter.gfLetterStatus ===
          guaranteeLetterOnlineStatusDict.AUDITING.value && in24Hours
      )
    },

    // 显示保函退款按钮
    showRefundButton() {
      /**
       * 满足下列其中一个条件时就显示：
       * 1、保函已开立且项目已重招；
       * 2、保函退款状态为退款失败
       */
      // 保函退款失败
      const REFUND_FAIL =
        this.letter.refundStatus ===
        guaranteeLetterOnlineRefundStatusDict.FAIL.value
      // 项目流标且已重招
      const RESTART = this.orderStatus === bidInviteBidStatusDict.RESTART.value
      // 保函已开立
      const HAS_LETTER =
        this.letter.gfLetterStatus ===
        guaranteeLetterOnlineStatusDict.OPENED.value
      return REFUND_FAIL || (RESTART && HAS_LETTER)
    },

    // 显示查看保函退款失败原因按钮
    showRefundFailButton() {
      return (
        this.letter.refundStatus ===
        guaranteeLetterOnlineRefundStatusDict.FAIL.value
      )
    },

    // 显示保函重新申请按钮
    showReApply() {
      // 当开立失败或退款成功时显示
      if (
        this.letter.refundStatus ===
        guaranteeLetterOnlineRefundStatusDict.REFUNDED.value
      ) {
        return true
      }
      if (
        this.letter.refundStatus ===
          guaranteeLetterOnlineRefundStatusDict.REFUNDING.value ||
        this.letter.refundStatus ===
          guaranteeLetterOnlineRefundStatusDict.FAIL.value
      ) {
        return false
      }
      if (
        this.letter.gfLetterStatus ===
        guaranteeLetterOnlineStatusDict.OPEN_FAIL.value
      ) {
        return true
      }
      return false
    }
  },

  created() {
    this.$store.dispatch('systemTime/getSystemTime')
    this.getLetterDetail()
  },

  methods: {
    /**
     * 申请线上保函
     */
    applyOnlineLetter() {
      this.$confirm('该服务由江咨金发线上服务平台提供', '在线保函申请', {
        confirmButtonText: '前往',
        cancelButtonText: '取消'
      })
        .then(() => {
          setGuaranteePayMethodApi(this.orderId, this.tradeId, {
            gfPayType: guaranteePayMethodDict.ONLINE_LETTER.value
          })
            .then(res => {
              getOnlineLetterUrlApi(params)
                .then(res => {
                  const _data = res.data || {}
                  // 获取江咨金发跳转链接
                  const url = _data.applyUrl || ''
                  // 如果没有获取url，则提示错误信息
                  if (!url) {
                    this.$message.info('对方系统正在升级中，请稍后尝试')
                    return
                  }

                  window.open(url, '_blank')
                  this.getLetterDetail()
                })
                .catch(err => {
                  console.error('获取线上保函失败', err)
                  if (err?.message) this.$message.error(err.message)
                })
            })
            .catch(err => {
              console.error('设置保证金缴费方式失败', err)
              if (err?.message) this.$message.error(err.message)
            })
          const params = {
            orderId: this.orderId,
            tradeId: this.tradeId
          }
        })
        .catch(() => {})
    },

    /**
     * 查询保函结果
     */
    getLetterDetail() {
      const params = {
        orderId: this.orderId,
        tradeId: this.tradeId
      }
      getGuaranteeLetterDetailApi(params)
        .then(res => {
          this.letter = res.data || {}
          this.$emit('getLetter', this.letter)
        })
        .catch(err => {
          console.error('查询保函结果失败', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 前往江咨金发平台查看进度
     */
    toThirdPlatform() {
      if (!this.letter.applyUrl) {
        this.$message.error('无法获取跳转地址，请刷新页面重试')
        return
      }
      window.open(this.letter.applyUrl, '_blank')
    },

    /**
     * 点击退款
     */
    async handleRefund() {
      // 保函已理赔，则不允许投标单位进行退款操作
      const IN_CLAIM = Boolean(this.letter.compensateStatus)
      if (IN_CLAIM) {
        this.$message.warning('采购人已申请理赔')
        return
      }

      const refundData = { orderId: this.orderId, tradeId: this.tradeId }
      // 项目已重招，则需要传递流标公告地址
      if (this.orderStatus === bidInviteBidStatusDict.RESTART.value) {
        refundData.noticeAddress =
          process.env.VUE_APP_PORTAL_URL +
          '/project/notice/' +
          this.closeNoticeId
      }
      try {
        const IS_CONFIRM = await this.$systemConfirm('是否申请退款')
        if (!IS_CONFIRM) return

        await applyRefundLetterApi(refundData)
        this.$message.success('已申请退款')
        await this.getLetterDetail()
      } catch (err) {
        console.error('在线保函退回失败', err)
        if (err?.message) this.$message.error(err.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-descriptions {
  .el-descriptions-item {
    vertical-align: top !important;
    padding-bottom: 16px !important;
  }
}

::v-deep .el-divider--horizontal {
  margin: 16px 0 !important;
}

.button-primary {
  color: $primary-color;
  cursor: pointer;

  &:hover {
    color: $primary-second-color;
  }
}

ol.tip,
.tip {
  font-size: 12px;
  color: $third-text-color;
}

ol.tip {
  margin-bottom: 0;
  padding-left: 12px;
  line-height: 2;
}

.opinion {
  background-color: $danger-fourth-color;
  border: 1px solid $danger-second-color;
  color: $text-color;
  font-size: 12px;
  @include text-bold;
  border-radius: 4px;
  padding: 8px 14px;
}
</style>
